const VerticalLayout = () => import('@/layouts/VerticalLayout')

const instructorRequests = () => import('./views/list.vue')
const instructorslist = () => import('./views/activeList.vue')
const instructorDetails = () => import('./views/details.vue')

export default [
  {
    path: '/instructor-requests',
    name: 'instructorRequests',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'instructorRequests',
      component: instructorRequests,
      meta: { name: 'instructorRequests', userType: 'admin', permission: 'instructor_list' }
    }
    ]
  },
  {
    path: '/instructors',
    name: 'instructors',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'instructors',
      component: instructorslist,
      meta: { name: 'instructors', userType: 'admin', permission: 'instructor_list' }
    },
    {
      path: ':id',
      name: 'admin.instructors.details',
      component: instructorDetails,
      meta: { name: 'instructorDetails', userType: 'admin', permission: 'instructor_list' }
    }
    ]
  }
]
